import React from 'react';
import Icon from '../../../components/AppIcon';

const SearchBar = ({ searchQuery, onSearchChange, resultCount }) => {
  return (
    <div className="relative">
      <div className="relative">
        <Icon 
          name="Search" 
          size={20} 
          className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          placeholder="Search articles, topics, keywords..."
          className="w-full pl-12 pr-4 py-3 md:py-3.5 bg-card border border-border rounded-xl text-sm md:text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all"
        />
      </div>
      {searchQuery && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-2">
          <span className="text-xs md:text-sm text-muted-foreground">
            {resultCount} {resultCount === 1 ? 'result' : 'results'}
          </span>
          <button
            onClick={() => onSearchChange('')}
            className="p-1.5 hover:bg-muted rounded-lg transition-colors"
            aria-label="Clear search"
          >
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchBar;